var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"lm-header"},[_c('h2',{staticClass:"title is-5",domProps:{"textContent":_vm._s(_vm.$t('Orders.title').toUpperCase())}}),_vm._v(" "),_c('h3',{staticClass:"subtitle is-5",domProps:{"textContent":_vm._s(_vm.$t('Common.filters'))}})]),_vm._v(" "),_c('order-filters'),_vm._v(" "),_c('orders')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-542108c1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/DashboardOrders.vue
// module id = null
// module chunks = 